/* eslint-disable no-case-declarations, guard-for-in, consistent-return, no-use-before-define, no-restricted-syntax, max-len */
import axios, { AxiosResponse } from 'axios';
import { MessageBox as Message } from 'element-ui';
import store from '@/modules/FPKG-50000-Vuex';
import { options, alerter } from '@/modules/FPKG-20000-Util/prototypes/axios';
import router from '../vueRouter';

export const domain = process.env.VUE_APP_URL ? window.location.hostname : 'default.tw';

export { options } from '@/modules/FPKG-20000-Util/prototypes/axios';

// axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

const Axios = axios.create(options);

Axios.interceptors.request.use((config: any) => {
  const configData = config;
  const authorisation = localStorage.getItem('x-authorisation');
  configData.headers['x-authorisation'] = authorisation;
  store.dispatch('openLoading');

  return configData;
},
  (error: object) => Promise.reject(error));

Axios.interceptors.response.use((response: any) => {
  const noHud = response.config.url !== `${response.config.baseURL}/hud/basic/lists`;
  store.dispatch('closeLoading');

  if (response.status !== 200) {
    return;
  }

  /** 例外的處理，不包含alert */
  exceptionHandle(response);

  /** 共用錯誤alerter */
  alerter(response.data.code);

  return response;
}, (error: object) => Promise.reject(error));


export default Axios;

/*
* 此處引入 router 會報 Maximum call stack size exceeded
* 所以使用window.location.href
*/
/** 進行例外處理動作 */
function exceptionHandle(response: AxiosResponse) {
  switch (response.data.code) {
    case 10015:
      store.dispatch('setLogin', false);
      break;
    case 10012:
      store.dispatch('setLogin', false);
      router.push({ name: 'login' });
      break;
    case 30002:
      store.dispatch('setLogin', false);
      router.push({ name: 'login' });
      break;
    case 20001:
      const data = [];
      for (const res in response.data.response) {
        data.push(response.data.response[res][0]);
      }
      Message.alert(`${data[0]}`);
      break;
    default:
      break;
  }
}
